import React, { Component, Fragment } from 'react';

import styles from './MainPageHero.css'
import fonts from '../../../styles/fonts.css'
import TerminalModal from './terminal/TerminalModal'

// Compact work history: one line per employer, resume-truth only
// (contract/side work like Photo Lab lives in the projects showcase below).
const WORK = [
    {
        years: '2022-now',
        company: 'etsy',
        place: 'seattle',
        line: 'senior machine learning engineer, recommendations - retrieval, ranking, real-time ML inference for 90M+ shoppers',
    },
    {
        years: '2018-22',
        company: 'amazon',
        place: 'seattle',
        line: 'senior software engineer - ML infrastructure for personalization; shipped on-device speech models for Alexa Hands-Free',
    },
    {
        years: '2017-18',
        company: 'zello',
        place: 'austin',
        line: 'software developer - real-time voice platform with 100M+ users',
    },
    {
        years: '2015-17',
        company: 'trucker path',
        place: 'san jose',
        line: 'software developer - led mobile team through 100x user growth',
    },
];

const SSH_COMMAND = 'ssh hi@trapeznikov.com';

class MainPageHero extends Component {
    state = { copied: false, terminalOpen: false };

    openTerminal = (e) => {
        // Drop focus from the play button: a later q/esc keypress would
        // otherwise upgrade its focus to :focus-visible and draw a ring.
        e.currentTarget.blur();
        this.setState({ terminalOpen: true });
    };

    closeTerminal = () => this.setState({ terminalOpen: false });

    copySshCommand = () => {
        var self = this;
        var markCopied = function () {
            self.setState({ copied: true });
            setTimeout(function () { self.setState({ copied: false }); }, 1500);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(SSH_COMMAND).then(markCopied);
        } else {
            var el = document.createElement('textarea');
            el.value = SSH_COMMAND;
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
            markCopied();
        }
    };

    render() {
        return (
            <Fragment>
                <div className={styles["hero-panel"]}>
                    <div className={[fonts["title-bold"], styles["hero-title"]].join(' ')}>
                        <span className={styles.prompt}>&gt;</span>
                        <span>whoami</span>
                    </div>
                    <div className={styles["hero-text"]}>
                        <p>
                            I&rsquo;m a machine learning engineer who ships
                            recommendation systems to 90M+ buyers at Etsy and
                            builds autonomous agent infrastructure after hours.
                        </p>
                        <p>
                            Before that - a decade of consumer products used by
                            hundreds of millions: on-device speech ML for Amazon Alexa,
                            personalization at Amazon, a 100M-user voice platform at
                            Zello, and the most popular trucker app in the US.
                        </p>
                        <p>
                            Outside of work I love exploring and collaborating.
                            That&rsquo;s how I teamed up with Photo Lab and helped make
                            it App Store and Google Play Best of 2017; nowadays
                            it&rsquo;s LLMs and autonomous agents - contributing
                            to <a href="https://github.com/app-vitals/shipwright"
                            target="_blank" rel="noopener noreferrer">shipwright&nbsp;<span className={styles["ext-arrow"]}>↗</span></a>,
                            an open-source AI software factory - and
                            writing <a href="/posts">posts</a> about what I find.
                        </p>
                        <p>
                            I also love meetups and conferences - swapping ideas and
                            seeing what others are building. Catch me regularly
                            at <a href="https://seattle.aitinkerers.org/" target="_blank"
                            rel="noopener noreferrer">AI Tinkerers Seattle&nbsp;<span
                            className={styles["ext-arrow"]}>↗</span></a>.
                        </p>
                    </div>
                    <div className={[fonts["title"], styles["work-header"]].join(' ')}>
                        $ work --history
                    </div>
                    <div className={styles["work-list"]}>
                        {WORK.map(function (w, i) {
                            return (
                                <div className={styles["work-row"]} key={i}>
                                    <span className={[fonts["title"], styles["work-years"]].join(' ')}>{w.years}</span>
                                    <span className={[fonts["title-bold"], styles["work-company"]].join(' ')}>{w.company}</span>
                                    <span className={[fonts["title"], styles["work-place"]].join(' ')}>{w.place}</span>
                                    <span className={styles["work-line"]}>{w.line}</span>
                                </div>
                            );
                        })}
                    </div>
                    <div className={[fonts["title"], styles["ssh-line"]].join(' ')}>
                        <span className={styles["ssh-prompt"]}>$</span>
                        <span className={styles["ssh-cmd"]}>{SSH_COMMAND}</span>
                        <span className={styles["ssh-comment"]}># this site, in your terminal · agents welcome</span>
                        <button className={[styles["ssh-copy"], styles["ssh-play"]].join(' ')} type="button"
                                title="run it in the browser" aria-label="open terminal in browser"
                                onClick={this.openTerminal}>
                            <svg className={styles["ssh-copy-icon"]} aria-hidden="true"
                                 xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                 fill="none" stroke="currentColor" strokeWidth="2"
                                 strokeLinecap="round" strokeLinejoin="round">
                                <polygon points="6 3 20 12 6 21 6 3"></polygon>
                            </svg>
                        </button>
                        <button className={styles["ssh-copy"]} type="button"
                                title="copy to clipboard" aria-label="copy ssh command"
                                onClick={this.copySshCommand}>
                            {this.state.copied ? (
                                <svg className={styles["ssh-copy-icon"]} aria-hidden="true"
                                     xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                     fill="none" stroke="currentColor" strokeWidth="2"
                                     strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="20 6 9 17 4 12"></polyline>
                                </svg>
                            ) : (
                                <svg className={styles["ssh-copy-icon"]} aria-hidden="true"
                                     xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                     fill="none" stroke="currentColor" strokeWidth="2"
                                     strokeLinecap="round" strokeLinejoin="round">
                                    <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                                    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                                </svg>
                            )}
                        </button>
                    </div>
                    {this.state.terminalOpen && (
                        <TerminalModal onClose={this.closeTerminal} />
                    )}
                </div>
            </Fragment>
        )
    }
}

export default MainPageHero;
